import React, { useState, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useOnboardingGate } from "../components/onboarding/OnboardingGate";

function GenerateLabel() {
  const { requireBusinessOps } = useOnboardingGate();
  const [file, setFile] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile && selectedFile.type !== "text/csv") {
      toast.error("Please upload a CSV file.");
      setFile(null);
    } else {
      setFile(selectedFile || null);
    }
  };

  const handleSubmit = async (event) => {
    const merchantId = localStorage.getItem("merchantId");
    const authToken = localStorage.getItem("authToken");
    event.preventDefault();
    if (!file) {
      toast.error("No file selected or file type is invalid.");
      return;
    }
    // Onboarding gate: generating labels requires an activated account. If locked, open the guided
    // onboarding overlay (the selected file is preserved).
    if (!requireBusinessOps('generate labels')) return;

    const formData = new FormData();
    formData.append("awbCsvMultipartFile", file);

    try {
      const apiUrl = `${process.env.REACT_APP_POCAS_BASE_URL}${process.env.REACT_APP_GENERATE_LABEL}${merchantId}`;
      const response = await axios.post(apiUrl, formData, {
        headers: {
          Authorization: authToken,
          "x-merchant-id": merchantId,
        },
      });

      if (response.status === 200) {
        toast.success("File uploaded successfully! Download will start soon.");
        setDownloadUrl(response.data.label_csv_file_url);
      }
    } catch (err) {
      console.error("Error uploading file:", err);
      toast.error("Failed to upload file.");
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleSampleDownload = () => {
    const link = document.createElement("a");
    link.href = "/multi_label_download_sample.csv";
    link.setAttribute("download", "multi_label_download_sample.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container mx-auto p-20">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">📦 Generate Shipping Labels</h1>

      {/* Label Upload Form */}
      <div className="bg-white p-6 shadow-lg rounded-lg border border-gray-200">
        <h2 className="text-xl font-semibold text-gray-700 mb-4">📝 Upload CSV for Labels</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="hidden"
              accept=".csv"
            />
            <div
              className="border border-dashed border-gray-400 p-6 text-center text-gray-600 rounded-md cursor-pointer"
              onClick={handleUploadClick}
            >
              {file ? file.name : "Click here to upload CSV file"}
            </div>
          </div>
          <div className="flex flex-col justify-end">
            <button
              className="bg-yellow-500 text-white px-4 py-2 rounded-lg"
              onClick={handleSubmit}
            >
              📂 Upload
            </button>
          </div>
        </div>
        <div className="mt-4 flex space-x-4 justify-end">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-lg"
            onClick={handleSampleDownload}
          >
            ⬇️ Sample CSV
          </button>
        </div>
      </div>

      {/* Download Section */}
      {downloadUrl && (
        <div className="mt-6 text-center bg-white p-6 shadow-lg rounded-lg border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">📥 Download Labels</h2>
          <a
            href={downloadUrl}
            className="bg-green-500 text-white px-4 py-2 rounded-lg inline-block"
            download
          >
            ⬇️ Download Label CSV
          </a>
        </div>
      )}
    </div>
  );
}

export default GenerateLabel;